import React from 'react';
import { Link } from 'react-router-dom';
import ArticleImage from '../common/ArticleImage';
import { IArticle } from '../../services/articleService';

export const authorName = (article: IArticle) =>
  [article.author_first_name, article.author_last_name].filter(Boolean).join(' ') ||
  [article.firstName, article.lastName].filter(Boolean).join(' ') || article.author_username || 'Heretic';
export const storyExcerpt = (article: IArticle) => article.excerpt || article.content.replace(/\\n/g, ' ').slice(0, 180) + '…';

const StoryCard: React.FC<{ article: IArticle; index?: number }> = ({ article }) => (
  <Link to={`/article/${article.slug || article.id}`} className="story-card">
    <div className="story-image">
      {article.imageUrl ? <ArticleImage src={article.imageUrl} alt={article.title} loading="lazy" /> : <div className="story-no-image"><span>{article.category}</span><span>H.</span></div>}
    </div>
    <div className="journal-caption">
      <div><h2>{article.title}</h2><span>{article.category}</span></div>
      <p>{storyExcerpt(article)}</p>
    </div>
  </Link>
);
export default StoryCard;
